<template>
  <div class="has-logo">
    <logo :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        background-color="#ebecf0"
        text-color="rgba(0,10,41,.6)"
        :unique-opened="false"
        :default-openeds="defaultOpeneds"
        active-text-color="#409EFF"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Logo from './Logo.vue';
import SidebarItem from './SidebarItem.vue';
import '@/styles/sidebar.less';

export default {
  components: {
    SidebarItem,
    Logo,
  },
  mounted() {
    window.$wujie?.bus.$on('sidebar', (status) => {
      this.$store.dispatch('setting/setSidebar', status);
    });
  },
  computed: {
    ...mapGetters(['sidebar']),
    routes() {
      const [, option] = this.$route.path.split('/');
      const routeMap = {
        appManage: 'appManage',
        poManage: 'appManage',
        workOrderManage: 'appManage',
        facilityManage: 'facilityManage',
        operationManage: 'facilityManage',
        boardManage: 'boardManage',
        platformManage: 'platformManage',
        serverCenter: 'platformManage',
        idcpManage: 'platformManage',
        servicer: 'appManage',
        billManage: 'appManage',
        auditManage: 'appManage',
        staffManage: 'appManage',
        translate: 'appManage',
        configManage: 'platformManage',
        networkManage: 'appManage',
      };

      const routeOption = routeMap[option];
      if (!routeOption) {
        return [];
      }
      return this.$router.options[routeOption];
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
    defaultOpeneds() {
      return [];
    },
  },
};
</script>
